import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from '../../common/components/Dialog';
import ChildSettingsForm  from './SettingsForm';

class ChildDetailsDialog extends Component {
    constructor(props) {
        super(props);
        this.handleSameAsParentChange = this.handleSameAsParentChange.bind(this);
        this.state = { sameAsParent: false };
    }

    handleSameAsParentChange() {
        this.setState({ sameAsParent: !this.state.sameAsParent });
    }

    renderBody() {
        const { child, genderTypes, onConfirm, onCancel, requireChildLastName, requireChildSchool, enableParentSelfBooking, hasSameAsParentChild } = this.props;

        return <ChildSettingsForm
            onSubmit={onConfirm}
            onCancel={onCancel}
            initialValues={child}
            requireChildLastName={requireChildLastName}
            requireChildSchool={requireChildSchool}
            enableParentSelfBooking={enableParentSelfBooking}
            genderTypes={genderTypes}
            sameAsParent={this.state.sameAsParent}
            sameAsParentChange={this.handleSameAsParentChange}
            hasSameAsParentChild={hasSameAsParentChild}
        />;
    }

    render() {
        const { onCancel, title, t, ...rest } = this.props;
        return <Dialog onHide={onCancel} header={title} body={this.renderBody()} footer={<div />} {...rest} />;
    }
}

export default ChildDetailsDialog;